
/**
 * @see https://github.com/calvinmetcalf/catiline
 * @see https://github.com/calvinmetcalf/leaflet.shapefile
 * @see https://github.com/calvinmetcalf/shapefile-js
 */
// import shpjs from "shpjs"; 
let { GeoJSON } = L;
/**
 * 
 */
L.Shapefile = GeoJSON.extend({
  options: {
    importUrl: T + 'plugins/shpfile/shp.js'
  },

  initialize(file, options) {
    L.setOptions(this, options);
    GeoJSON.prototype.initialize.call(this, {
      features: []
    }, options);
    //
    // import(/* webpackChunkName: "catiline" */'../../libs/catiline').then(cw => {
    //   this.cw = cw;
    //   let { isArrayBuffer, importUrl } = this.options;
    //   if (!isArrayBuffer) {
    //     this.worker = cw(new Function('data', 'cb', 'importScripts("' + importUrl + '");shp(data).then(cb);'));
    //   } else {
    //     this.worker = cw(new Function('data', 'importScripts("' + importUrl + '"); return shp.parseZip(data);'));
    //   }
    //   this.addFileData(file);
    // })
    // require.ensure([], () => {
    //   var cw = require('../../libs/catiline');
    // }, 'catiline')
    T.require([T + 'plugins/catiline.js'], cw => {
      this.cw = cw;
      let { isArrayBuffer, importUrl } = this.options;
      if (!isArrayBuffer) {
        this.worker = cw(new Function('data', 'cb', 'importScripts("' + importUrl + '");shp(data).then(cb);'));
      } else {
        this.worker = cw(new Function('data', 'importScripts("' + importUrl + '"); return shp.parseZip(data);'));
      }
      this.addFileData(file);
    })
  },

  addFileData: function (file) {
    let self = this;
    let { cw } = self;
    this.fire('data:loading');
    if (typeof file !== 'string' && !('byteLength' in file)) {
      var data = this.addData(file);
      this.fire('data:loaded');
      return data;
    }
    if (!this.worker) {
      shp(file).then(function (data) {
        self.addData(data);
        self.fire('data:loaded');
      });
      return this;
    }
    var promise;
    if (this.options.isArrayBufer) {
      promise = this.worker.data(file, [file]);
    } else {
      promise = this.worker.data(cw.makeUrl(file));
    }

    promise.then(function (data) {
      self.addData(data);
      self.fire('data:loaded');
      self.worker.close();
    });
    return this;
  }
});

L.shapefile = function (a, b, c) {
  return new L.Shapefile(a, b, c);
};


// WEBPACK FOOTER //
// ./src/polyfill/Shp.js